import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProviderListComponent } from './pages/provider/provider-list/provider-list.component';
import { ProfessionalListComponent } from './pages/professional/professional-list/professional-list.component';
import { DisciplineListComponent } from './pages/discipline/discipline-list/discipline-list.component';
import { HomeComponent } from './pages/home/home.component';

const routes: Routes = [
  { path: '', redirectTo: '/providers', pathMatch: 'full' },
  {
    path: 'providers',
    component: ProviderListComponent,
  },
  {
    path: 'professionals',
    component: ProfessionalListComponent,
  },
  {
    path: 'disciplines',
    component: DisciplineListComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },

  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  { path: '**', redirectTo: '/providers' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
